import { render, staticRenderFns } from "./EvaluationSummaryTab.vue?vue&type=template&id=4f38720a&"
import script from "./EvaluationSummaryTab.vue?vue&type=script&lang=js&"
export * from "./EvaluationSummaryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports